import React, { Component } from 'react';
import {
    Box,
    Typography,
    Paper,
    Switch,
    Grid,
    TextField,
    Button,
    InputAdornment,
    Checkbox
} from '@mui/material';

// Ícones do MUI baseados na imagem de Entrega
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import StorefrontIcon from '@mui/icons-material/Storefront';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import PublicIcon from '@mui/icons-material/Public';
import AddIcon from '@mui/icons-material/Add';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { toast } from 'react-toastify';
import MelhorEnvioSection from './MelhorEnvioSection';

// Estilo dos Switches roxos
const purpleSwitchSx = {
    '& .MuiSwitch-switchBase.Mui-checked': { color: '#9061f9' },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#9061f9' }
};

class SecaoEntrega extends Component {
    constructor(props) {
        super(props);
        this.state = {
            habilitarEntrega: false,
            entregaLocal: false,
            retiradaLocal: false,
            melhorEnvio: false,

            // Campos do formulário de Entrega Local
            valorEntrega: 0,
            gratisAcima: 0,
            distanciaMaxima: 0,
            tempoMin: 0,
            tempoMax: 0,

            // Transportadoras Habilitadas do Melhor Envio
            transportadoras: {
                pac: true,
                sedex: true,
                pacMini: false,
                jadlog: false
            }
        };
    }

    componentDidMount() {
        const { data } = this.props;
        if (data) {
            this.setState(data);
        }
    }

    handleToggleChange = (key) => (event) => {
        this.setState({ [key]: event.target.checked });
    };

    handleInputChange = (key) => (event) => {
        this.setState({ [key]: event.target.value });
    };

    handleTransportadoraChange = (key) => (event) => {
        const { transportadoras } = this.state;
        this.setState({
            transportadoras: {
                ...transportadoras,
                [key]: event.target.checked
            }
        });
    };

    // Abre a rota de autenticação OAuth do Melhor Envio
    handleConectarMelhorEnvio = () => {
        const apiUrl = process.env.REACT_APP_API_URL || 'https://api.fazpedido.com.br';
        window.open(`${apiUrl}/auth/melhorenvio/connect`, '_blank');
    };

    render() {
        const {
            habilitarEntrega,
            entregaLocal,
            retiradaLocal,
            melhorEnvio,
            valorEntrega,
            gratisAcima,
            distanciaMaxima,
            tempoMin,
            tempoMax,
            transportadoras
        } = this.state;

        return (
            <Box sx={{ p: 0, bgcolor: '#ffffff', minHeight: '100vh', fontFamily: 'sans-serif' }}>

                {/* Título Principal */}
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a202c', mb: 0.5 }}>
                    Entrega
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>
                    Frete e regiões
                </Typography>

                {/* Card Principal: Habilitar Entrega */}
                <Paper
                    variant="outlined"
                    sx={{
                        p: 2.5,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderRadius: '12px',
                        borderColor: '#e2e8f0',
                        mb: 4
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{ p: 1.5, bgcolor: '#f3e8ff', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <LocalShippingIcon sx={{ color: '#9061f9' }} />
                        </Box>
                        <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: '600', color: '#1a202c' }}>
                                Habilitar entrega
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Oferecer opções de frete aos clientes
                            </Typography>
                        </Box>
                    </Box>
                    <Switch
                        checked={habilitarEntrega}
                        onChange={this.handleToggleChange('habilitarEntrega')}
                        sx={purpleSwitchSx}
                    />
                </Paper>

                {/* Se o switch geral estiver ativo, exibe as opções abaixo */}
                {habilitarEntrega ? (
                    <Box>
                        {/* --- SEÇÃO: ENTREGA LOCAL --- */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <LocationOnIcon fontSize="small" sx={{ color: '#64748b' }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                                    Entrega Local
                                </Typography>
                            </Box>
                            <Switch
                                checked={entregaLocal}
                                onChange={this.handleToggleChange('entregaLocal')}
                                sx={purpleSwitchSx}
                            />
                        </Box>

                        {entregaLocal ? (
                            <Paper variant="outlined" sx={{ p: 3, borderRadius: '12px', borderColor: '#e2e8f0', mb: 4, bgcolor: '#fcfcfd' }}>
                                <Grid container spacing={3}>
                                    {/* Valor da entrega */}
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="body2" sx={{ fontWeight: '500', mb: 1, color: '#1a202c' }}>
                                            Valor da entrega
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            value={valorEntrega}
                                            onChange={this.handleInputChange('valorEntrega')}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                            }}
                                            sx={{ bgcolor: '#ffffff' }}
                                        />
                                    </Grid>

                                    {/* Grátis acima de */}
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="body2" sx={{ fontWeight: '500', mb: 1, color: '#1a202c' }}>
                                            Grátis acima de
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            placeholder="Deixe vazio para desativar"
                                            value={gratisAcima}
                                            onChange={this.handleInputChange('gratisAcima')}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                            }}
                                            sx={{ bgcolor: '#ffffff' }}
                                        />
                                    </Grid>

                                    {/* Distância máxima */}
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="body2" sx={{ fontWeight: '500', mb: 1, color: '#1a202c' }}>
                                            Distância máxima (km)
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            size="small"
                                            value={distanciaMaxima}
                                            onChange={this.handleInputChange('distanciaMaxima')}
                                            sx={{ bgcolor: '#ffffff' }}
                                        />
                                    </Grid>

                                    {/* Tempo estimado */}
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="body2" sx={{ fontWeight: '500', mb: 1, color: '#1a202c' }}>
                                            Tempo estimado
                                        </Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <TextField
                                                type="number"
                                                size="small"
                                                value={tempoMin}
                                                onChange={this.handleInputChange('tempoMin')}
                                                sx={{ width: '80px', bgcolor: '#ffffff' }}
                                            />
                                            <Typography variant="body2" color="textSecondary">a</Typography>
                                            <TextField
                                                type="number"
                                                size="small"
                                                value={tempoMax}
                                                onChange={this.handleInputChange('tempoMax')}
                                                sx={{ width: '80px', bgcolor: '#ffffff' }}
                                            />
                                            <Typography variant="body2" color="textSecondary">min</Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Paper>
                        ) : null}


                        {/* --- SEÇÃO: RETIRADA NO LOCAL --- */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <StorefrontIcon fontSize="small" sx={{ color: '#64748b' }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                                    Retirada no Local
                                </Typography>
                            </Box>
                            <Switch
                                checked={retiradaLocal}
                                onChange={this.handleToggleChange('retiradaLocal')}
                                sx={purpleSwitchSx}
                            />
                        </Box>


                        {/* --- SEÇÃO: MELHOR ENVIO --- */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: melhorEnvio ? 2 : 4 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <FlashOnIcon fontSize="small" sx={{ color: '#64748b' }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                                    Melhor Envio
                                </Typography>
                            </Box>
                            <Switch
                                checked={melhorEnvio}
                                onChange={this.handleToggleChange('melhorEnvio')}
                                sx={purpleSwitchSx}
                            />
                        </Box>

                        {/* PAINEL DO MELHOR ENVIO (EXIBIDO APENAS QUANDO O SWITCH ESTIVER LIGADO) */}
                        {melhorEnvio ? (<MelhorEnvioSection />) : null}


                        {/* --- SEÇÃO: ZONAS DE ENTREGA --- */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <PublicIcon fontSize="small" sx={{ color: '#64748b' }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                                    Zonas de Entrega
                                </Typography>
                            </Box>
                            <Button
                                variant="outlined"
                                size="small"
                                disabled
                                startIcon={<AddIcon />}
                                sx={{
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    color: '#1a202c',
                                    borderColor: '#e2e8f0',
                                    fontWeight: '600',
                                    '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f8fafc' }
                                }}
                            >
                                Adicionar zona
                            </Button>
                        </Box>

                        {/* Área pontilhada vazia para Zonas de Entrega */}
                        <Box
                            sx={{
                                border: '1px dashed #e2e8f0',
                                borderRadius: '12px',
                                p: 6,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 1,
                                bgcolor: '#fafafa'
                            }}
                        >
                            <LocalShippingIcon sx={{ color: '#cbd5e1', fontSize: 40 }} />
                            <Typography variant="body2" sx={{ color: '#718096', fontWeight: '500' }}>
                                Nenhuma zona de entrega configurada
                            </Typography>
                        </Box>

                    </Box>
                ) : null}

                {/* Botão de Salvar */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        mt: 4,
                        pt: 2,
                        borderTop: '1px solid #eee'
                    }}
                >
                    <Button
                        variant="contained"
                        startIcon={<SaveOutlinedIcon />}
                        onClick={() => {
                            fetch(`${process.env.REACT_APP_API_URL}/settings/delivery`, {
                                method: 'POST',
                                credentials: 'include',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(this.state),
                            })
                                .then(response => {
                                    if (response.ok) {
                                        toast.success('Configurações atualizadas com sucesso!');
                                    } else {
                                        toast.error('Erro ao atualizar as configurações.');
                                    }
                                })
                                .catch(error => {
                                    console.error('Erro ao atualizar as configurações:', error);
                                });
                        }}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            bgcolor: '#6200ee',
                            px: 4,
                            '&:hover': { bgcolor: '#4a00b8' }
                        }}
                    >
                        Salvar
                    </Button>
                </Box>
            </Box>
        );
    }
}

export default SecaoEntrega;